<template>
  <div>
    <customList :filterItems="formItems" :filterModel="filter"  @selectChange="selectChange" :columns="columns" :listUrl="'/admin/loginlog/list'" ref="customList">
    </customList>
  </div>
</template>

<script>

export default {
  name: 'loginLogList',
  data () {
    return {
      settleModalstatus: false,
      settleUpdateModalstatus: false,
      formItems: [
        { label: '姓名', model: 'name' },
        { label: '手机号', model: 'mobile' },
        { type: 'select', label: '状态', model: 'delStatus', options: [{ name: '全部', value: '' }, { name: '可用', value: 0 }, { name: '禁用', value: 1 }], fun: 'selectChange' },
        { type: 'button', buttonArr: [{ message: '查询', type: 'primary', fun: 'selectChange' }] }
      ],
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '姓名', key: 'user_name', fixed: 'left' },
        { title: '手机号', key: 'mobile', minWidth: 300 },
        {
          title: '创建时间',
          key: 'create_time',
          width: 130,
          render: (h, params) => {
            const dbDatetime = new Date(params.row.create_time);
            return h('div', [
              h('span', {}, params.row.create_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        { title: 'ip', key: 'ip', width: 100 }
      ]
    };
  },
  methods: {
  },
  mounted () {
    this.columns.forEach((item) => {
      this.$set(item, 'align', 'center');
    });
  }
};
</script>
<style scoped>
</style>
